/**
 * Lista över svenska orter/städer för autocomplete
 * Sorterad alfabetiskt, max 20 tecken per ortnamn
 */
export const SWEDISH_CITIES = [
  'Alingsås',
  'Alfta',
  'Älmhult',
  'Älvdalen',
  'Älvkarleby',
  'Älvsbyn',
  'Ammarnäs',
  'Anderslöv',
  'Arboga',
  'Arjeplog',
  'Arvika',
  'Askersund',
  'Avesta',
  'Bengtsfors',
  'Berg',
  'Bjuv',
  'Boden',
  'Bollnäs',
  'Bollebygd',
  'Borgholm',
  'Borlänge',
  'Borås',
  'Bromölla',
  'Brunflo',
  'Bålsta',
  'Båstad',
  'Dals-Ed',
  'Danderyd',
  'Degerfors',
  'Dorotea',
  'Eda',
  'Ekerö',
  'Eksjö',
  'Emmaboda',
  'Enköping',
  'Eskilstuna',
  'Eslöv',
  'Fagersta',
  'Falkenberg',
  'Falköping',
  'Falun',
  'Filipstad',
  'Finspång',
  'Flen',
  'Forshaga',
  'Gagnef',
  'Gällivare',
  'Gislaved',
  'Gnesta',
  'Gnosjö',
  'Grums',
  'Grästorp',
  'Gullspång',
  'Gunnarn',
  'Gävle',
  'Göteborg',
  'Götene',
  'Habo',
  'Hagfors',
  'Hallsberg',
  'Hallstahammar',
  'Halmstad',
  'Hammarö',
  'Haparanda',
  'Heby',
  'Hedemora',
  'Helsingborg',
  'Herrljunga',
  'Hjo',
  'Hofors',
  'Hova',
  'Hudiksvall',
  'Huskvarna',
  'Härnösand',
  'Hässleholm',
  'Högsby',
  'Höganäs',
  'Hörby',
  'Höör',
  'Järna',
  'Jokkmokk',
  'Jönköping',
  'Kalix',
  'Kalmar',
  'Karlsborg',
  'Karlshamn',
  'Karlskoga',
  'Karlskrona',
  'Karlstad',
  'Katrineholm',
  'Kil',
  'Kinna',
  'Kiruna',
  'Klippan',
  'Kramfors',
  'Kristianstad',
  'Kristinehamn',
  'Krokom',
  'Kumla',
  'Kungsbacka',
  'Kungshamn',
  'Kungälv',
  'Kävlinge',
  'Köping',
  'Laholm',
  'Landskrona',
  'Laxå',
  'Leksand',
  'Lerum',
  'Lessebo',
  'Lidingö',
  'Lidköping',
  'Lilla Edet',
  'Lindesberg',
  'Linköping',
  'Ljungby',
  'Ljusdal',
  'Lund',
  'Ludvika',
  'Luleå',
  'Lycksele',
  'Lyrestad',
  'Lysekil',
  'Malmberget',
  'Malmö',
  'Malung',
  'Mariefred',
  'Mariestad',
  'Markaryd',
  'Mjölby',
  'Mora',
  'Motala',
  'Mullsjö',
  'Munkfors',
  'Mölndal',
  'Mönsterås',
  'Nacka',
  'Nora',
  'Norberg',
  'Norrköping',
  'Norrtälje',
  'Nyköping',
  'Nynäshamn',
  'Nässjö',
  'Ockelbo',
  'Olofström',
  'Orsa',
  'Orust',
  'Oskarshamn',
  'Oxelösund',
  'Pajala',
  'Partille',
  'Piteå',
  'Robertsfors',
  'Ronneby',
  'Sala',
  'Sandviken',
  'Sätila',
  'Sigtuna',
  'Simrishamn',
  'Sjöbo',
  'Skara',
  'Skellefteå',
  'Skinnskatteberg',
  'Skövde',
  'Smedjebacken',
  'Sollefteå',
  'Sollentuna',
  'Solna',
  'Sorsele',
  'Staffanstorp',
  'Stockholm',
  'Storuman',
  'Strängnäs',
  'Strömsund',
  'Strömstad',
  'Sundbyberg',
  'Sunne',
  'Sundsvall',
  'Surahammar',
  'Svalöv',
  'Svenljunga',
  'Säffle',
  'Säter',
  'Sävsjö',
  'Söderhamn',
  'Söderköping',
  'Södertälje',
  'Sölvesborg',
  'Tibro',
  'Tidaholm',
  'Tierp',
  'Timrå',
  'Tingsryd',
  'Tomelilla',
  'Torsby',
  'Torsås',
  'Tranemo',
  'Tranås',
  'Trelleborg',
  'Trollhättan',
  'Trosa',
  'Töreboda',
  'Täby',
  'Töre',
  'Uddevalla',
  'Ulricehamn',
  'Umeå',
  'Upplands Väsby',
  'Uppsala',
  'Vadstena',
  'Vaggeryd',
  'Valdemarsvik',
  'Vallentuna',
  'Vansbro',
  'Vara',
  'Varberg',
  'Vaxholm',
  'Vetlanda',
  'Vilhelmina',
  'Vimmerby',
  'Vindeln',
  'Vingåker',
  'Värnamo',
  'Västervik',
  'Västerås',
  'Vänersborg',
  'Växjö',
  'Ystad',
  'Åmål',
  'Ånge',
  'Ängelholm',
  'Åre',
  'Årjäng',
  'Arvidsjaur',
  'Åseda',
  'Åsele',
  'Åstorp',
  'Åtvidaberg',
  'Öckerö',
  'Ödeshög',
  'Örebro',
  'Örnsköldsvik',
  'Östersund',
  'Österåker',
  'Östhammar',
  'Överkalix',
  'Övertorneå',
];
